/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: { borderColor: '#676e73', textLine: 'none' }
    },
    {
      if: { focus: true },
      tokens: {
        borderBottomWidth: 3,
        borderColor: '#676e73',
        borderLeftWidth: 3,
        borderRightWidth: 3,
        borderTopWidth: 3
      }
    },
    {
      if: { selected: true },
      tokens: {
        backgroundColor: '#676e73',
        color: '#ffffff',
        textLine: 'none'
      }
    },
    {
      if: { pressed: true },
      tokens: { backgroundColor: '#676e73', color: '#ffffff' }
    }
  ],
  tokens: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderBottomWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0)',
    borderLeftWidth: 1,
    borderRadius: 32,
    borderRightWidth: 1,
    borderTopWidth: 1,
    color: '#676e73',
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '400',
    height: 32,
    lineHeight: 1.5,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 4,
    outerBorderWidth: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
    textAlign: 'center',
    textLine: 'underline',
    width: 32
  }
}
export default theme
